var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgListToggle = function SvgListToggle(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5C0 2.23858 2.23858 0 5 0H7C9.76142 0 12 2.23858 12 5V7C12 9.76142 9.76142 12 7 12H5C2.23858 12 0 9.76142 0 7V5ZM5 4C4.44772 4 4 4.44772 4 5V7C4 7.55228 4.44772 8 5 8H7C7.55228 8 8 7.55228 8 7V5C8 4.44772 7.55228 4 7 4H5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 21C0 18.2386 2.23858 16 5 16H7C9.76142 16 12 18.2386 12 21V23C12 25.7614 9.76142 28 7 28H5C2.23858 28 0 25.7614 0 23V21ZM5 20C4.44772 20 4 20.4477 4 21V23C4 23.5523 4.44772 24 5 24H7C7.55228 24 8 23.5523 8 23V21C8 20.4477 7.55228 20 7 20H5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 37C0 34.2386 2.23858 32 5 32H7C9.76142 32 12 34.2386 12 37V39C12 41.7614 9.76142 44 7 44H5C2.23858 44 0 41.7614 0 39V37ZM5 36C4.44772 36 4 36.4477 4 37V39C4 39.5523 4.44772 40 5 40H7C7.55228 40 8 39.5523 8 39V37C8 36.4477 7.55228 36 7 36H5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 5C16 2.23858 18.2386 0 21 0H39C41.7614 0 44 2.23858 44 5V7C44 9.76142 41.7614 12 39 12H21C18.2386 12 16 9.76142 16 7V5ZM21 4C20.4477 4 20 4.44772 20 5V7C20 7.55228 20.4477 8 21 8H39C39.5523 8 40 7.55228 40 7V5C40 4.44772 39.5523 4 39 4H21Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 21C16 18.2386 18.2386 16 21 16H39C41.7614 16 44 18.2386 44 21V23C44 25.7614 41.7614 28 39 28H21C18.2386 28 16 25.7614 16 23V21ZM21 20C20.4477 20 20 20.4477 20 21V23C20 23.5523 20.4477 24 21 24H39C39.5523 24 40 23.5523 40 23V21C40 20.4477 39.5523 20 39 20H21Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 37C16 34.2386 18.2386 32 21 32H39C41.7614 32 44 34.2386 44 37V39C44 41.7614 41.7614 44 39 44H21C18.2386 44 16 41.7614 16 39V37ZM21 36C20.4477 36 20 36.4477 20 37V39C20 39.5523 20.4477 40 21 40H39C39.5523 40 40 39.5523 40 39V37C40 36.4477 39.5523 36 39 36H21Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgListToggle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list-toggle.957195e7.svg";
export { ForwardRef as ReactComponent };